import React from "react";
import '../styles/header.css'
// import { useNavigate } from "react-router-dom";

export default function Header() {

    // const navigation = useNavigate();

    const date = new Date()
    const hours = date.getHours();
    const greeting = hours < 12 ? 'Good morning!': hours > 18 ? 'Good evening!' : 'Good afternoon!';

    // return (
    //     <div id="header">
    //         <div class="header-text">
    //             <h2 id="greeting">{greeting}</h2>
    //             <text id="header-text">Welcome to my portfolio, my name is Jonne.</text>
    //         </div>
    //         {window.location.pathname !== '/' && <button class="back-arrow" onClick={() => navigation(-1)}>&lt;</button>}
    //     </div>
    // )

    return (
    <header className="text-center py-8">
      <h1 className="text-amber-200/90 mb-2">{greeting}</h1>
      <p className="text-amber-100/70">Welcome to my portfolio, my name is Jonne.</p>
    </header>
  );
}